import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MsalAuthenticationTemplate, withMsal } from '@azure/msal-react';
import * as Msal from '@azure/msal-browser';

import Navigation from './../../Navigation';
import * as actionsLogin from './../../../data/login/actions.js';
import Timer from './../../Timer';
import { login } from './../../../settings/settings';
import { httpStatus, JWTOKEN, STAFFID } from './../../../data/constants/';
import { fetchLoginMsal, logout } from '../../../data/login/productionActions';


let loginListener;
class MsalMainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staff: {}
    };
  }
  componentDidMount() {
    const msalInstance = this.props.msalContext.instance;
    if (loginListener !== null) {
      msalInstance.removeEventCallback(loginListener);
    }

    msalInstance.addEventCallback((event) => {
      // set active account after redirect
      if (event.eventType === Msal.EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);

        sessionStorage.setItem(STAFFID, event.payload.idTokenClaims.OBLIX_ID);
        sessionStorage.setItem(JWTOKEN, JSON.stringify(event.payload.idToken));
      }
    });

    const staffId = sessionStorage.getItem(STAFFID);
    const jwToken = sessionStorage.getItem(JWTOKEN);
    if (staffId && jwToken) {
      this.props.fetchLoginMsal();
      this.props.getUserInformation(staffId).then((response) => {
        const responseData = response.data;
        if (responseData.status && responseData.status === httpStatus.UNAUTHORIZED) {
          logout('/login');
          // Preserve language preference
          const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
          sessionStorage.clear();
          // Restore language preference
          if (tempLng) {
            localStorage.setItem('lng', tempLng);
            sessionStorage.setItem('lng', tempLng);
          }
        } else {
          this.setState({ staff: response.data });
        }
      }).catch((error) => {
        logout('/login');
        // Preserve language preference
        const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
        sessionStorage.clear();
        // Restore language preference
        if (tempLng) {
          localStorage.setItem('lng', tempLng);
          sessionStorage.setItem('lng', tempLng);
        }
      });
    }
  }

  render() {
    return (
      <MsalAuthenticationTemplate interactionType={Msal.InteractionType.Redirect}>
        <Timer
          waitingTime={login.maxIdleTime}
          onTimeout={this.props.expireSession}
        >
          <main>
            <Navigation
              user={this.props.user}
              logout={this.props.logout}
              staff={this.state.staff}
            />
            {this.props.children}
          </main>
        </Timer>
      </MsalAuthenticationTemplate>
    );
  }
}

MsalMainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  expireSession: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  getUserInformation: PropTypes.func.isRequired,
  fetchLoginMsal: PropTypes.func.isRequired,
  staff: PropTypes.object.isRequired
};

MsalMainLayout.defaultProps = {
  children: {},
  expireSession: () => {},
  logout: () => {},
  getUserInformation: () => {},
  fetchLoginMsal: () => {},
  user: {},
  staff: {}
};

const mapDispatchToProps = dispatch => ({
  expireSession: () => dispatch(actionsLogin.default.expireSession()),
  logout: path => dispatch(actionsLogin.default.logout(path)),
  redirect: path => dispatch(actionsLogin.default.logout(path)),
  getUserInformation: staffId =>
    dispatch(actionsLogin.default.getUserInformation(staffId)),
  fetchLoginMsal: () => dispatch(actionsLogin.default.fetchLoginMsal())
});

const mapStateToProps = state => ({ ...state.login });

export default withMsal(connect(mapStateToProps, mapDispatchToProps)(MsalMainLayout));
